import request from "@/config/serve.js";

// 查询
export function getAccountDetailList(params) {
  return request("post", "/apiGo/api/v1/settlement/review/list", params);
}
//开发者充值管理-审核查询
export function getAccountDetail(data) {
  return request("get", "/developerAccount/getAccountDetail", data);
}
//开发者充值管理-充值审核
export function auditRecharge(data) {
  return request("post", "/apiGo/api/v1/settlement/review", data);
}
//获取满足激励政策
export function getRechargeGive(data) {
  return request("get", "/developerAccount/getLaunch", data);
}
//充值审核校验
export function getCheckStatus(data) {
  return request("post", "/settlement/review/list", data);
}
// 获取应用列表
export function getAppList(params) {
  return request("post", "/apiGo/api/v1/app/appList", params);
}
// 获取投放者名称
export function getDeveloperUserList(params) {
  return request("get", "/apiGo/api/v1/developerUser/list", params);
}
//发送邮件
export function sendMail(params) {
  return request("post", "/apiGo/api/v1/settlement/review/email", params);
}
